// src/components/workflow/HtmlComponent.jsx
import {
  CalendarClock,
  ChevronDown,
  ClipboardType,
  Hash,
  Image,
  Key,
  Mail,
  Palette,
  Phone,
  QrCode,
  Receipt,
  SquareArrowOutUpRight,
  SquareDashedKanban,
  Text,
  TicketCheckIcon,
} from "lucide-react";

// Pre-defined list of available field components
export const htmlComponents = [
  {
    name: "",
    label: "",
    displayName: "Text",
    icon: ClipboardType,
    type: "text",
    validation: "min:0|max:255",
  },
  {
    name: "",
    label: "",
    displayName: "Email",
    icon: Mail,
    type: "email",
    validation: "email",
  },
  {
    name: "",
    label: "",
    displayName: "Number",
    icon: Hash,
    type: "number",
    validation: "min:0|max:1000000",
  },
  {
    name: "",
    label: "",
    displayName: "Phone Number",
    icon: Phone,
    type: "tel",
    validation: "tel",
  },
  {
    name: "",
    label: "",
    displayName: "Textbox",
    icon: Text,
    type: "textarea",
    validation: "min:0|max:1000",
  },
  {
    name: "",
    label: "",
    displayName: "Dropdown",
    icon: ChevronDown,
    type: "select",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "Plate Number",
    icon: SquareDashedKanban,
    type: "plate_number",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "Date Time",
    icon: CalendarClock,
    type: "datetime",
    validation: "date_format:Y-m-d H:i:s",
  },
  {
    name: "",
    label: "",
    displayName: "Image Upload",
    icon: Image,
    type: "image",
    validation: "mimes:jpg,png|max:2048",
  },
  {
    name: "",
    label: "",
    displayName: "Color Picker",
    icon: Palette,
    type: "color",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "QR Scan",
    icon: QrCode,
    type: "scan_qr",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "QR Code",
    icon: QrCode,
    type: "qr_code",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "OTP",
    icon: Key,
    type: "otp",
    validation: "digits:6",
  },
  {
    name: "",
    label: "",
    displayName: "Popup",
    icon: SquareArrowOutUpRight,
    type: "popup",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "Receipt",
    icon: Receipt,
    type: "receipt",
    validation: "",
  },
  {
    name: "",
    label: "",
    displayName: "Ticket Summary",
    icon: TicketCheckIcon,
    type: "ticket_summary",
    validation: "",
  },
].map((c, i) => ({
  ...c,
  step_field_id: i + 1,
  required: false,
  options: null,
  order: i + 1,
}));
